/**
 * @Author: 71
 * @Date: 2026-07-29 18:00:39
 * @LastEditTime: 2026-08-21 17:00:15
 * @LastEditors: 71
 * @Description: 
 * @FilePath: \aigoes-school-web\src\config\index.js
 * @苍天eye有，bug木有~~
 */
/** init domain config */
import Vue from 'vue'
//设置全局API_BASE_URL
Vue.prototype.API_BASE_URL = window._CONFIG.VUE_APP_API_BASE_URL?window._CONFIG.VUE_APP_API_BASE_URL:process.env.VUE_APP_API_BASE_URL
window._CONFIG['domianURL'] = Vue.prototype.API_BASE_URL
// 资源/文件服务地址
window._CONFIG['resourceURL'] = window._CONFIG.VUE_APP_RESOURCE_URL ? window._CONFIG.VUE_APP_RESOURCE_URL : process.env.VUE_APP_RESOURCE_URL
//单点登录地址
window._CONFIG['casPrefixUrl'] = window._CONFIG.VUE_APP_CAS_BASE_URL?window._CONFIG.VUE_APP_CAS_BASE_URL:process.env.VUE_APP_CAS_BASE_URL
window._CONFIG['onlinePreviewDomainURL'] =  window._CONFIG.VUE_APP_ONLINE_BASE_URL?window._CONFIG.VUE_APP_ONLINE_BASE_URL:process.env.VUE_APP_ONLINE_BASE_URL
window._CONFIG['staticDomainURL'] = Vue.prototype.API_BASE_URL + '/sys/common/static'
window._CONFIG['pdfDomainURL'] = Vue.prototype.API_BASE_URL+ '/sys/common/pdf/pdfPreviewIframe'